import moment from "moment";

const isBegOfDay = (timestamp) => {
  const time = moment(timestamp);
  // Check if the time is 12:00 AM
  return time.hour() === 0 && time.minute() === 0;
};

export default isBegOfDay;
